import React from 'react';
import { HeaderText } from '@etiquette-ui/dynamic-table-components';
import BasicText from 'components/DynamicTable/DynamicTableComponents/cells/BasicText';
import RowActions from './cells/Actions';
import RowContainer from 'components/Table/RowContainer';
import RoleUserGrid from 'components/Table/RoleUserGrid';
import SortText from 'components/Table/headers/SortText';

const structure = {
    row: RowContainer,
    columns: [
        {
            flex: 2,
            header: ({globalState, ...rest}) => <SortText property={'name'} text={globalState.config.translate('Name')} {...rest}/>,
            body: ({ item }) => <BasicText text={item.name} style={{ marginLeft: '12px', marginTop: '10px', alignItems: 'start' }} />,
        },
        {
            flex: 8,
            header: ({ globalState }) => <HeaderText text={globalState.config.translate('Employees')} />,
            body: ({item, globalState}) => <RoleUserGrid users={item.users} groupId={globalState.config.groupId}/>,
        },
        {
            flex: 2,
            header: () => <HeaderText text={''} />,
            body: RowActions,
        },
    ],
};

export default structure;